/**
 * Formats a Date into the display format: "Friday 23 February 2026"
 */
export const getTodayDate = (date: Date = new Date()): string => {
  return new Intl.DateTimeFormat('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
    .format(date)
    .replace(/,/g, '');
};
